module.exports = require("yaml-js");


//////////////////
// WEBPACK FOOTER
// external "yaml-js"
// module id = 608
// module chunks = 0